module.exports = __webpack_public_path__ + "static/media/part-number-coding2.0.23c91ef7.png";